const Menu = [
  {
    label: "Home",
    pathname: "/mod/home"
  },
  {
    label: "Chatrooms",
    pathname: "/mod/chatrooms",
  },
  {
    label: "Logout",
    pathname: "/logout"
  },
]

export default Menu;